import { render, staticRenderFns } from "./CustomerCardNet.vue?vue&type=template&id=9718d8d0"
import script from "./CustomerCardNet.vue?vue&type=script&lang=ts"
export * from "./CustomerCardNet.vue?vue&type=script&lang=ts"
import style0 from "./CustomerCardNet.vue?vue&type=style&index=0&id=9718d8d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports